import ClipboardJS from 'clipboard';

angular
    .module('tradersyard')
    .directive('postNode', [
        '$parse',
        '$flex',
        'graph-post-factory',
        '$compile',
        '$timeout',
        '$rootScope',
        function ($parse, $flex, $client, $compile, $timeout, $rootScope) {
            return {
                scope: false,
                link: function ($scope, $element, $attr) {
                    $scope.mode = 'read';
                    // $scope.showComments = false;
                    $scope.placeView = $attr.placeView !== undefined;
                    $scope.entry = $parse($attr.entry)($scope);
                    $scope.entryId = $parse($attr.entryId)($scope);

                    var clipboard = new ClipboardJS('.post-link-clipboard-button-' + $scope.node.id);

                    clipboard.on('success', function (e) {});

                    clipboard.on('error', function (e) {
                        var _element = document.querySelector('.post-link-clipboard-button-' + $scope.node.id);

                        var urlAddress = angular.element(_element).attr('data-clipboard-text');

                        window.prompt('Copy to clipboard: Ctrl+C, Enter', urlAddress);
                    });

                    $scope.postDelete = function (node) {
                        $client
                            .entry()
                            .delete(node.id)
                            .then(function (response) {
                                if (response.data.state === 0) {
                                    /**
                                     * Stop an iframe or HTML5 <video> from playing
                                     * @param  {Element} element The element that contains the video
                                     */
                                    var stopVideo = function (element) {
                                        var iframe = element.querySelector('iframe');
                                        var video = element.querySelector('video');
                                        if (iframe) {
                                            var iframeSrc = iframe.src;
                                            iframe.src = iframeSrc;
                                        }
                                        if (video) {
                                            video.pause();
                                        }
                                    };

                                    stopVideo(document);

                                    $element[0].style.display = 'none';
                                    // $compile($element.contents())($scope);
                                }
                            });
                    };

                    $scope.openDocument = function (documentObj) {
                        if (documentObj.type === 'text/plain') {
                            readTextFile(buildDocumentUrl(documentObj)).then(function (text) {
                                $rootScope.$broadcast('graph-modal-show', {
                                    title: documentObj.name,
                                    content: text,
                                    type: documentObj.type,
                                });
                                setTimeout(function () {
                                    //magic for modal open
                                    var icon = document.querySelector('.icon');
                                    icon.click();
                                }, 0);
                            });
                        } else if (documentObj.type === 'application/pdf') {
                            $rootScope.$broadcast('graph-modal-show', { title: documentObj.name });
                            var documentContainer = document.querySelector('.document-container');

                            PDFObject.embed(buildDocumentUrl(documentObj), documentContainer);
                        } else {
                            download(documentObj);
                        }
                    };

                    function buildDocumentUrl(documentObj) {
                        return location.origin + '/' + documentObj.base_path;
                    }

                    function readTextFile(filePath) {
                        var txt = '';
                        return new Promise(function (resolve) {
                            var xmlhttp = new XMLHttpRequest();
                            xmlhttp.onreadystatechange = function () {
                                if (xmlhttp.status === 200 && xmlhttp.readyState === 4) {
                                    txt = xmlhttp.responseText;
                                    resolve(txt);
                                }
                            };

                            xmlhttp.open('GET', filePath, true);
                            xmlhttp.send();
                        });
                    }

                    function download(documentObj) {
                        var link = document.createElement('a');
                        link.download = documentObj.name;
                        link.href = documentObj.source;
                        link.click();
                    }

                    $timeout(function () {
                        var self = $parse($attr.postNode)($scope);
                        $scope.$on('post:delete', function (e, node) {
                            try {
                                if (parseInt(self.id) === parseInt(node.id)) {
                                    $scope.postDelete(self);
                                }
                            } catch (error) {
                                console.log(error);
                            }
                        });
                    });

                    // $scope.fn = {
                    //     mode: function (mode) {
                    //         if (mode === 'edit') {
                    //
                    //         }
                    //
                    //         $scope.mode = mode;
                    //     }
                    // };

                    $scope.touch = function (name) {
                        $scope.$broadcast('touch:' + name);
                        // setTimeout(function() {
                        //     if ($scope.showComments) {
                        //         $scope.showComments = false;
                        //     } else {
                        //         $scope.showComments = true;
                        //     }
                        // }, 0);
                    };
                    // $scope.post = $parse($attr.postNode)($scope);

                    // console.log($scope.post);
                    // $scope.like
                },
            };
        },
    ])
    .controller('post-read-ctrl', [
        '$scope',
        'graph-post-factory',
        '$flex',
        function ($scope, $factory, $flex) {
            angular.extend($scope, $flex.data);
        },
    ]);
